import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from '../styles/LockNotification.module.css';

const LockNotification = ({ message, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000); // Notification disappears after 5 seconds

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={styles.notification}>
      {message}
    </div>
  );
};

LockNotification.propTypes = {
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default LockNotification;
